import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { initialize } from 'redux-form';
import { push } from 'connected-react-router';
import { useTranslation } from 'react-i18next';

import { MainFormControls } from 'src/jbc-front/components/SearchForm';
import styles from 'src/components/DetailSearchForm.scss';
import IncomeTaxDeclarationAdditionalSearchFields from './IncomeTaxDeclarationAdditionalSearchFields';

const selectRouterLocation = state => state.router.location;

const IncomeTaxDeclarationSearchForm = ({ menuRender: Menu, formName, resetValues, resetSearch = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useSelector(selectRouterLocation);

  return (
    <div className="u-mb20">
      <div className={styles.mainSearchFields}>
        <MainFormControls
          isExpand={isExpanded}
          hasConditions={location.search !== '' && location.search !== `?${resetSearch}`}
          onToggleClick={() => {
            setIsExpanded(!isExpanded);
          }}
          handleClear={() => {
            dispatch(initialize(formName, resetValues));
            dispatch(push({ ...location, search: resetSearch }));
          }}
          searchPlaceholder={t('features.ReportIncomeTax.list.search.placeholder')}
        />
        <Menu />
      </div>
      {isExpanded && <IncomeTaxDeclarationAdditionalSearchFields />}
    </div>
  );
};

IncomeTaxDeclarationSearchForm.propTypes = {
  menuRender: PropTypes.func.isRequired,
  formName: PropTypes.string.isRequired,
  resetValues: PropTypes.shape({
    q: PropTypes.string,
    year: PropTypes.number,
    offices: PropTypes.string
  }).isRequired,
  resetSearch: PropTypes.string
};

IncomeTaxDeclarationSearchForm.defaultProps = {
  resetSearch: ''
};

export default IncomeTaxDeclarationSearchForm;
